<mat-chip-list>
  <ng-container *ngFor="let tag of selectedTags; trackBy: trackTag">
    <mat-chip
      [style.backgroundColor]="tag.isSystem ? '#141217' : '#2C2A30'"
      size="sm"
      (click)="selectTag(tag)"
      class="selectedTags"
    >
      <div class="selectedTagsLabel">
        <span>{{ tag.name }}</span>
      </div>
    </mat-chip>
  </ng-container>

  <a
    snChip
    size="sm"
    *ngIf="tags.length > this.tagsLimit"
    [matMenuTriggerFor]="menu"
    (click)="$event.stopPropagation()"
  >
    {{ 'common.all' | t }}
  </a>
</mat-chip-list>

<mat-menu #menu="matMenu" xPosition="after">
  <div class="menu-content">
    <mat-chip-list>
      <mat-chip
        *ngFor="let tag of tags; trackBy: trackTag"
        (click)="selectTag(tag)"
        size="sm"
        class="menuChips"
      >
        <div class="menuChipLabels">
          <span>{{ tag.name }}</span>
        </div>
      </mat-chip>
    </mat-chip-list>
  </div>
</mat-menu>
